import { ForwardIcon, BackwardIcon } from "../components/Icons";
import { useVideoPlayer2 } from "../hooks/use-video-player-2-setup-start";
import { useVideoPlayer2ForwardRewind } from "../hooks/useVideoPlayer2Play";

export function VideoForwardRewindButtons() {
  const { forward, rewind } = useVideoPlayer2ForwardRewind();
  const player = useVideoPlayer2();

  return (
    <>
      <button
        aria-label={player.trans("rewind")}
        title={player.trans("rewind")}
        className="video-player-2-btn video-player-2-forward-rewind-btn"
        onClick={() => rewind(10)}
      >
        <BackwardIcon />
      </button>
      <button
        aria-label={player.trans("forward")}
        title={player.trans("forward")}
        className="video-player-2-btn video-player-2-forward-rewind-btn"
        onClick={() => forward(10)}
      >
        <ForwardIcon />
      </button>
    </>
  );
}
